module.exports = __webpack_public_path__ + "img/1.39b88d62.png";